import React from 'react';
import { LogoMolecule } from '../../molecules';
import { MenuIconMolecule } from '../../molecules/menu-icon';
import { MobileMenuSidebarOrganism } from '../mobile-menu-sidebar';
import { useTitleBarToggleEffect } from './title-bar-toggle.effect';
import { TitleBarProps } from './title-bar.props';

export const TitleBarOrganism = (props: TitleBarProps) => {
  const [mobileMenuOpened, toggleMobileMenu, closeMobileMenu] =
    useTitleBarToggleEffect(false);

  return (
    <section
      data-cy="title-bar"
      id="main-nav"
      className={`flex justify-between items-center z-30 pt-3 pb-2 lg:pt-4  mt-0 ${props.addClass}`}
    >
      <nav className="w-2/5">
        <MenuIconMolecule toggleMenu={toggleMobileMenu} className="xl:hidden" />
        <MobileMenuSidebarOrganism
          mobileMenuLinks={props.links}
          opened={mobileMenuOpened}
          closeMenu={closeMobileMenu}
        />
      </nav>
      <LogoMolecule />
      <nav className="w-2/5" />
    </section>
  );
};
